import { configInit } from 'redux/reducers/init';
import {
  requestConfigList,
  requestConfigListFailure,
  requestConfigListSuccess,
} from 'redux/actions/actions';

import { createReducer } from '@reduxjs/toolkit';

const config = createReducer(configInit, {
  [requestConfigList.type]: (state, action) => {
    state.isLoading = true;
  },
  [requestConfigListSuccess.type]: (state, action) => {
    const { config } = action.payload;
    state.isInit = true;
    state.isLoading = false;
    state.config = config;
  },
  [requestConfigListFailure.type]: (state, action) => {
    state.isInit = false;
    state.isLoading = false;
    state.config.forcedHideTeam = [];
    state.config.forcedShowTeam = [];
  },
});

export default config;
